module.exports = __webpack_public_path__ + "img/LamdeiniLearning-129.d09e3f1e.jpg";